import styled from "styled-components";

export const ContractText = styled.div`
  padding: 24px 16px 12px 16px;
  font-size: 1.02rem;
  color: ${({ theme }) => theme.colors.text};
`;
export const SignatureBox = styled.div`
  background: #fafafa;
  border-radius: 10px;
  margin: 0 16px 8px 16px;
  border: 1.5px solid ${({ theme }) => theme.colors.lightGray};
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 180px;
`;
export const SignatureCanvas = styled.canvas`
  border-radius: 10px;
  background: #fff;
  width: 100%;
  height: 180px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
`;
export const ClearButton = styled.button`
  width: 96%;
  margin: 8px 2% 16px 2%;
  background: ${({ theme }) => theme.colors.error};
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 13px 0;
  font-size: 1.06rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s;
  &:hover {
    background: ${({ theme }) => theme.colors.errorDark};
  }
`;
export const ErrorText = styled.div`
  color: ${({ theme }) => theme.colors.error};
  font-size: 0.98rem;
  margin: 6px 0 0 16px;
`;
export const SubmitButton = styled.button`
  width: 96%;
  margin: 32px 2% 0 2%;
  background: ${({ theme }) => theme.colors.secondary};
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 14px 0;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;
  &:hover {
    background: ${({ theme }) => theme.colors.secondaryDark};
  }
`;